import React, { PureComponent } from 'react'

import PropTypes from 'prop-types'
import filesize from 'filesize'
import sdk from 'matrix-react-sdk'
import { _t } from 'matrix-react-sdk/lib/languageHandler'
import CheckboxV2 from 'shared/ui/CheckboxV2'
import { getMatrixClient } from 'ducks/chat/utils/client'
import { getFileSizeLimit } from 'ducks/chat/utils/rooms'
import styles from './styles.less'

export default class UploadConfirmDialog extends PureComponent {
  static propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    file: PropTypes.object.isRequired,
    currentIndex: PropTypes.number,
    totalFiles: PropTypes.number,
    onFinished: PropTypes.func.isRequired,
  }

  static defaultProps = {
    totalFiles: 1,
    currentIndex: 0,
  }

  constructor(props) {
    super(props)
    this._objectUrl = URL.createObjectURL(props.file)
    this.state = {
      isNote: false,
    }
  }

  componentDidMount() {
    this.checkFileSizeLimit()
  }

  componentWillUnmount() {
    if (this._objectUrl) URL.revokeObjectURL(this._objectUrl)
  }

  onCancelClick = () => {
    const { onFinished } = this.props
    const { isNote } = this.state
    onFinished(false, false, { isNote })
  }

  onUploadClick = () => {
    const { onFinished } = this.props
    const { isNote } = this.state
    onFinished(true, false, { isNote })
  }

  onUploadAllClick = () => {
    const { onFinished } = this.props
    const { isNote } = this.state
    onFinished(true, true, { isNote })
  }

  toggleNote = () => {
    const { isNote } = this.state
    this.setState({
      isNote: !isNote,
    })
  }

  checkFileSizeLimit = () => {
    const client = getMatrixClient()
    const room = client.getRoom(this.props.roomId)

    this.setState({
      fileSizeLimit: getFileSizeLimit(room),
    })
  }

  render() {
    const { totalFiles, currentIndex, file } = this.props
    const { isNote } = this.state
    const BaseDialog = sdk.getComponent('views.dialogs.BaseDialog')
    const DialogButtons = sdk.getComponent('views.elements.DialogButtons')

    let title
    if (totalFiles > 1 && currentIndex !== undefined) {
      title = _t('Upload files (%(current)s of %(total)s)', {
        current: currentIndex + 1,
        total: totalFiles,
      })
    } else {
      title = _t('Upload files')
    }

    let preview
    if (file.type.startsWith('image/')) {
      preview = (
        <div className="mx_UploadConfirmDialog_previewOuter">
          <div className="mx_UploadConfirmDialog_previewInner">
            <div>
              <img
                className="mx_UploadConfirmDialog_imagePreview"
                src={this._objectUrl}
                alt={file.name}
              />
            </div>
            <div>
              {file.name} ({filesize(file.size)})
            </div>
          </div>
        </div>
      )
    } else {
      preview = (
        <div>
          <div>
            {file.name} ({filesize(file.size)})
          </div>
        </div>
      )
    }

    const hasMoreFiles = currentIndex + 1 < totalFiles

    if (file.size > this.state.fileSizeLimit) {
      const message = _t(
        'This file is <b>too large</b> to upload. ' +
          'The file size limit is %(limit)s but this file is %(sizeOfThisFile)s.',
        {
          limit: filesize(10000),
          sizeOfThisFile: filesize(file.size),
        },
        {
          b: sub => <b>{sub}</b>,
        }
      )
      return (
        <BaseDialog
          className="mx_UploadFailureDialog"
          onFinished={this.onCancelClick}
          title={_t('Upload Error')}
          contentId="mx_Dialog_content"
        >
          <div id="mx_Dialog_content">{message}</div>

          <DialogButtons
            primaryButton={_t('OK')}
            hasCancel={false}
            onPrimaryButtonClick={this.onCancelClick}
            focus
          />
        </BaseDialog>
      )
    }

    return (
      <BaseDialog
        className="mx_UploadConfirmDialog"
        fixedWidth={false}
        onFinished={this.onCancelClick}
        title={title}
        contentId="mx_Dialog_content"
      >
        <div id="mx_Dialog_content">{preview}</div>

        <DialogButtons
          primaryButton={_t('Upload')}
          hasCancel={false}
          onPrimaryButtonClick={this.onUploadClick}
          focus
        >
          {hasMoreFiles && (
            <button
              className={styles.uploadAllButton}
              onClick={this.onUploadAllClick}
            >
              {_t('Upload all')}
            </button>
          )}
        </DialogButtons>
        <CheckboxV2
          onClick={this.toggleNote}
          label="Post attachment as a comment"
          checked={isNote}
        />
      </BaseDialog>
    )
  }
}
